import { shrpaApi } from "./axios";
import type { NearbyDiscoveryTrace, NearbyExplainResult, NearbyImportResult, NearbyRun, NearbySuggestion } from "@contracts/nearbyLocations";

const root = (customerId: string) => `/customer-nearby-locations/${encodeURIComponent(customerId)}`;
export default {
  async list(customerId: string): Promise<NearbySuggestion[]> {
    return (await shrpaApi.get(root(customerId))).data;
  },
  async runs(customerId: string): Promise<NearbyRun[]> {
    return (await shrpaApi.get(`${root(customerId)}/runs`)).data;
  },
  /** Superuser: the detailed diagnostics saved for one discovery run. */
  async trace(customerId: string, runId: string): Promise<NearbyDiscoveryTrace> {
    return (await shrpaApi.get(`${root(customerId)}/runs/${encodeURIComponent(runId)}/trace`)).data;
  },
  /** Superuser: "why was this place missed?" for one run (makes one Google request). */
  async explain(customerId: string, runId: string, query: string): Promise<NearbyExplainResult[]> {
    return (await shrpaApi.post(`${root(customerId)}/runs/${encodeURIComponent(runId)}/explain`, { query })).data;
  },
  async start(customerId: string, input: Record<string, unknown>): Promise<NearbyRun> {
    return (await shrpaApi.post(`${root(customerId)}/runs`, input)).data;
  },
  async update(customerId: string, id: string, input: Record<string, unknown>): Promise<NearbySuggestion> {
    return (await shrpaApi.put(`${root(customerId)}/${encodeURIComponent(id)}`, input)).data;
  },
  async socials(customerId: string, suggestionIds: string[]): Promise<NearbyRun> {
    return (await shrpaApi.post(`${root(customerId)}/socials`, { suggestionIds })).data;
  },
  /** approvePending: the server treats Pending suggestions as approved by this request. */
  async import(customerId: string, calendarId: string | null, items: Record<string, unknown>[], approvePending = false): Promise<NearbyImportResult[]> {
    return (await shrpaApi.post(`${root(customerId)}/import`, { calendarId, items, approvePending })).data;
  },
};
